<template>
    <div class="main-container">
        <van-button @click="pay">支付</van-button>
        <van-button @click="uploadGameRole">上报角色</van-button>
        <van-button @click="repeatLogin">登录被顶</van-button>
    </div>
</template>


<script>

import {md5} from '@/utils/md5'
import {Toast} from "vant";

export default {
    name: 'gameTest5',
    data() {
        return {
            gameId: 2,
            userId: 1,
            h5GameSdk: null,
            sdkInit: false,
            testKey : 'xxxxxxxxxxxxxxxxxxxxxxxxxxxx',
            sdkUrl : 'https://huiwanyx.com/static/js/huiwan.sdk.js',
        };
    },
    mounted() {
        this.importJs();
        setTimeout(() => {
            this.initH5GameSdk();
        }, 1000)
    },
    methods: {
        importJs() {
            const oScript = document.createElement('script');
            oScript.type = 'text/javascript';
            oScript.src = this.sdkUrl;
            document.body.appendChild(oScript);
        },
        initH5GameSdk() {
            this.h5GameSdk = window.HUIWAN_H5_SDK;
            if (this.h5GameSdk) {
                let params = {gameId : this.gameId};
                this.h5GameSdk.config(params); //初始化
                this.sdkInit = true;
            }
        },
        uploadGameRole() {
            if(this.checkSdkInit()) return;
            let roleParam = {
                gameId: this.gameId,
                userId: this.userId,
                serverId: "146",
                serverName: "146服",
                roleId: "146002",
                roleName: "ls",
                roleLevel: "22",
                combatNum: "20001",
                eventType: "1",
                partyId: "20",
                partyMasterId: "146002",
                partyMasterName: "老大",
                partyName: "宗门1",
                vipLevel: "1",
            };
            roleParam.sign = this.sign(roleParam)
            this.h5GameSdk.uploadGameRole(roleParam);
        },
        checkSdkInit() {
            if (!this.sdkInit) {
                this.initH5GameSdk();
                Toast('sdk还未初始化成功，请稍后重试');
                return true;
            }
            else {
                return false;
            }
        },
        //⽤户点击商品下单
        pay() {
            if(this.checkSdkInit()) return;
            let order = {
                gameId: this.gameId,
                userId: this.userId,
                money: "100",
                cpOrderId: "TEST_2025_" + new Date().getTime(),
                goodsName: "10钻石",
                serverId: "146",
                roleId: "146001",
                roleName: "zs",
                time: new Date().getTime() + "",
            };
            order.sign = this.sign(order)
            this.h5GameSdk.pay(order);
        },
        //登录被顶
        repeatLogin() {
            if(this.checkSdkInit()) return;
            this.h5GameSdk.repeatLogin();
        },
        sign(data) {
            let sortedParam = this.sorter(data);
            let needSignatureStr = "";
            for (let key in sortedParam) {
                let value = sortedParam[key];
                if (value) {
                    needSignatureStr = needSignatureStr + key + '=' + value + '&';
                }
            }
            needSignatureStr += this.testKey;
            console.log('需加密串:' + needSignatureStr);
            let sign = md5(needSignatureStr)
            console.log('加密结果:' + sign);
            return sign;
        },
        sorter(inObject) {
            let sortedJson = {};
            let sortedKeys = Object.keys(inObject).sort();
            for (let i = 0; i < sortedKeys.length; i++) {
                sortedJson[sortedKeys[i]] = inObject[sortedKeys[i]]
            }
            return sortedJson;
        },
    }
}
</script>

<style scoped>
.main-container {

}
</style>
